export const team = {
    phxBastards: "Phoenix Bastards",
    domHawks: "Dom's Hawks",
    bMovieBlazers: "B-Movie Blazers",
    philoozers: "philoozers",
    orlDunk: "Orlando DunkN GoNutz",
    chi88: "chicago88",
    denver: "Carden Vermello",
    detJews: "Detroit Jews 33",
    bknNets: "Brooklyn Nets",
    saMcdyess: "San Antonio McDyess",
    gswRandolph: "GSWrandolph",
    crashlots: "The Crashalot Bobcat",
    laPoets: "LaLaPoets",
    mavs: "Cuban & The Banshees",
    uthFlames: "Utah Flames"
}

export const manager = {
    yevgeny: "יבגני",
    dom: "דום",
    nissim: "ניסים",
    itay: "איתי",
    jDog: "ג'יי-דוג",
    ran: "רן",
    asa: "אסא",
    kobe: "קובי",
    mati: "מתי",
    spurs: "מי זוכר?",
    sagi: "שגיא",
    ariel: "אריאל",
    darko: "דארקו",
    inbal: "ענבל",
    michael: "מיכאל",
    oded: "עודד",
    chauncey: "צ'ונסי",
    idan: "עידן",
    alon: "אלון",
    zeev: "זאב",
    shiran: "שירן",
    ilya: "איליה",
    dror: "דרור",
    rony: "רוני",
    yoni: "יוני",
    shahar: "שחר",
    ben: "בן"
}

export const keeper = {
    franchise: "שחקן פרנצ'ייז",
    free: "קיפר חופשי",
    yearFour: "שחקן השבחה",
    yearThree: "סליפר שנה שלישית",
    yearTwo: "סליפר סופמור",
    yearOne: "סליפר רוקי"
}